export const NEXT_API_URL =
  process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3018';

// export const NEXT_API_URL2 = process.env.BZ_URL2;
// #For local
// export const NEXT_API_URL2 = 'http://localhost:3018';
 export const NEXT_API_URL_title =
   process.env.NEXT_PUBLIC_ICON_TITLE || 'http://localhost:3018/bizcareui';
